export var menuItems={
  "data": [
    {
      "headTitle1": "General",
      "headTitle2": "Dashboards,Widgets & Layout.",
      "type": "headtitle"
    },
    {
      "title": "Dashboard",
      "icon": "home",
      "type": "link",
      "path": "/dashboard",
      // "badgeType": "light-primary",
      // "badgeValue": "5",
      "active": true,
    },
    {
      "title": "Rewards History",
      "icon": "star",
      "type": "link",
      "path": "/rewards",
      // "badgeType": "light-primary",
      // "badgeValue": "5",
      "active": true,
    },
    {
      "title": "Subscription",
      "iconType": 'sprite',
      "icon": "coin",
      "type": "link",
      "path": "/packages_subscription",
      "active": false,
    },
    {
      "title": "Payment History",
      "icon": "dollar-sign",
      "type": "link",
      "path": "/payment-history",
      "active": false,
    },
    {
      "title": "Child Accounts",
      "icon": "clipboard",
      "type": "sub",
      "active": false,
      // "badgeType": "light-primary",
      // "badgeValue": "5",
      "children":[
        {
          "path": "/dna-report/application",
          "title": "Application Status",
          "type": "link",
          "active":false
        },
        {
          "path": "/dna-report/apply",
          "title": "Register Your Child",
          "type": "link",
          "active":false
        },
      ]
    },
    {
      "title": "Forum",
      "iconType": 'sprite',
      "icon": "stroke-chat",
      // "type": "extLink",
      "type": "link",
      // "path": "https://localhost:4200",
      "path": '/forum',
      // "path": process.env.VUE_APP_FORUM_HOST + '/session/sso',
      // "path": 'https://carexera-forum.syamim.design' + '/session/sso',
      "active": false,
    },
    {
      "headTitle1": "Miscellaneous",
      "type": "headtitle"
    },
    {
      "title": "FAQ",
      "icon": "alert-circle",
      "type": "link",
      "path": "/support",
      "active": false,
    },
    {
      "title": "System Feedback",
      "icon": "message-square",
      "type": "link",
      "path": "/system-feedback",
      "active": false,
    },
    {
      "title": "Support Ticket",
      "iconType": 'sprite',
      "icon": "stroke-icons",
      "type": "link",
      "path": "/support_ticket",
      "active": false,
    },
    
  ]
}